import React from "react";

const ErrorBanner = ({ message }) => {
    if (!message || !message.trim()) return null;

    return (
        <div className="py-9 bg-secondary">
            <div className="p-4 bg-warning-bg-red text-center text-sm text-white">
                {message}
            </div>
        </div>
    );
};

export default ErrorBanner;